/* Replace only standalone typographic checks. No network, storage or observers. */
(function () {
  'use strict';
  if (window.ZVStraightChecks) { window.ZVStraightChecks.refresh(); return; }
  var skip = 'script,style,noscript,template,input,textarea,select,option,svg,math,pre,code,kbd,samp,' +
    '[contenteditable]:not([contenteditable="false"]),[role="checkbox"],[role="radio"],[role="switch"],' +
    '[role="menuitemcheckbox"],[role="menuitemradio"],[data-zv-straight-check-skip],.zv-straight-check';

  function excluded(parent) {
    if (!parent || parent.closest(skip)) return true;
    var label = parent.closest('label');
    var control = label && (label.control || label.querySelector('input'));
    return !!(control && /^(checkbox|radio)$/i.test(control.type));
  }

  function makeCheck(glyph) {
    var wrapper = document.createElement('span');
    wrapper.className = 'zv-straight-check';
    // Preserve the original accessible text; the new vector is decorative.
    var text = document.createElement('span');
    text.className = 'zv-straight-check__text';
    text.textContent = glyph;
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'zv-straight-check__svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '24'); svg.setAttribute('height', '24');
    svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.5');
    svg.setAttribute('stroke-linecap', 'butt'); svg.setAttribute('stroke-linejoin', 'miter');
    svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    var line = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    line.setAttribute('points', '5,12 9,16 19,6');
    svg.appendChild(line); wrapper.appendChild(text); wrapper.appendChild(svg);
    return wrapper;
  }

  function refresh(root) {
    root = root || document.body;
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11)) return 0;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node, matches = [];
    while ((node = walker.nextNode())) {
      // A check within prose or with an emoji variation selector is untouched.
      if (/^\s*[\u2713\u2714]\s*$/.test(node.nodeValue) && !excluded(node.parentElement)) matches.push(node);
    }
    matches.forEach(function (original) {
      var parts = original.nodeValue.match(/^(\s*)([\u2713\u2714])(\s*)$/);
      var fragment = document.createDocumentFragment();
      if (parts[1]) fragment.appendChild(document.createTextNode(parts[1]));
      fragment.appendChild(makeCheck(parts[2]));
      if (parts[3]) fragment.appendChild(document.createTextNode(parts[3]));
      original.parentNode.replaceChild(fragment, original);
    });
    return matches.length;
  }

  window.ZVStraightChecks = { refresh: refresh };
  document.addEventListener('shopify:section:load', function (event) { refresh(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); }, { once: true });
  } else refresh();
})();
